import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from 'react-feather';

interface TabProps {
  url: string;
  Icon: Icon;
	label?: string;
}

const Tab: React.FC<TabProps> = ({ url, Icon, label }) => {
  const location = useLocation()

  const isActive = location.pathname === url || (location.pathname === '/' && url === '/legend');
  const classes = `tab ${isActive ? 'active' : ''}`;

  return (
    <li className={classes}>
      <Link to={isActive ? '/map' : url} aria-label={label}>
        <Icon aria-hidden="true" focusable="false" />
      </Link>
    </li>
  );
};

export default Tab;